Pegasus.TemplateRoute = Ember.Route.extend({
  activate: function(){
    Pegasus.set('loaded', true);
  },
  deactivate: function(){
    Pegasus.set('loaded', false);
  },
  model: function(params){
    return this.store.all(Pegasus.WebTemplate).get('lastObject');
  },
  setupController: function(controller, model){
    this._super(controller, model);
    this.controllerFor('themes').set('content', this.store.all(Pegasus.Theme));
  },
  actions: {
    hideOperations: function(){
      var blockOps = Pegasus.lookupController('blockOperations');
      blockOps.set('content', null);
    },

    loadPreview: function(result){
      var template = this.modelFor('template');

      Em.run(this, function(){
        template.set('html', result.message);
      });
      this.controllerFor('templatePreview').set('content', Em.Object.create(result));
      this.transitionTo('template.preview');
    },

    showPreview: function(){
      if ( window.parent === window ) {
        Pegasus.IOManager.generateOutput(true, function(result){
          this.send('loadPreview', result);
        }.bind(this));
        return;
      }

      this.controllerFor('frameCommManager').set('pendingAction', 'loadPreview');
      this.controllerFor('autoSave').saveSnapshot(true);
    },

    saveAndPreview: function(idObject){
      this.send('showPreview');
    },

    didLoadTemplate: Em.K
  }
});
